import { useEffect, useState } from 'react';
import { useAbly } from '@poplar/hooks/useAbly';
export var useAblyChannel = function useAblyChannel(channelName, ablyMessageCallback) {
  var _useAbly = useAbly(),
      ably = _useAbly.ably,
      error = _useAbly.error;

  var _useState = useState(null),
      channel = _useState[0],
      setChannel = _useState[1];

  useEffect(function () {
    if (ably && channelName && !channel) {
      var realtimeChannel = ably.channels.get(channelName);
      void realtimeChannel.subscribe(ablyMessageCallback);
      setChannel(realtimeChannel);
      return function () {
        realtimeChannel.unsubscribe(ablyMessageCallback);

        if (realtimeChannel.state === 'attached') {
          void realtimeChannel.detach();
        }
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [ably, channelName]);
  return {
    ably: ably,
    channel: channel,
    error: error
  };
};